jQuery(document).ready(function($) {
  if (!$('.technology-new-insights').length) {
    return;
  }
  if ($(window).width() < 992) {
    TechnologyInsights($);
  }
});


function TechnologyInsights($) {
  $('.technology-new-insights-step-tab').click(function(){
		var tab_id = $(this).attr('data-tab');    

		$('.technology-new-insights-step-tab').removeClass('technology-new-insights-step-tab-active');
		$('.technology-new-insights-step-content').removeClass('technology-new-insights-step-content-active');

		$(this).addClass('technology-new-insights-step-tab-active');
		$('#'+tab_id).addClass('technology-new-insights-step-content-active');

    if ($('.technology-new-insights-step-tab2').hasClass('technology-new-insights-step-tab-active')) {
      $('.technology-new-insights-step-tab-or1').addClass('blue');
    } else {
      $('.technology-new-insights-step-tab-or1').removeClass('blue');
    }
	})
}



// WEBPACK FOOTER //
// ./scripts/blocks/technology-new-insights.js